import PAINTZEN_ZIP_CODES from './paintzenZipcodes';
import { Reward } from './types';

// If we add rewards by state on other brands,
// For the arcadia reward we will need to add a new url for the brand
// and add more logic here Cesar C. 11/12/2023
const ARCADIA_URL_$40 =
  'https://www.arcadia.com/ownerlylp-national?utm_source=ownerly&utm_medium=partner&utm_campaign=ownerly40&promo=ownerly40';

const CLEAR_ESTATE_VALID_STATES = ['NY', 'TX', 'AZ', 'FL', 'CA', 'NV'];

const BUBBLE_VALID_STATES = [
  'AZ',
  'CA',
  'FL',
  'IN',
  'NC',
  'NJ',
  'OH',
  'OR',
  'PA',
  'SC',
  'TN',
  'TX',
  'WA',
  'WI',
];

const ARCADIA_VALID_STATES = ['NY', 'MA', 'MD', 'ME', 'CO', 'IL', 'RI'];

const REWARDS_FILTER_LIST = ['bubble', 'clearestate', 'paintzen', 'arcadia'];

export const isValidStateForClearEstateOffer = (state: string) =>
  CLEAR_ESTATE_VALID_STATES.includes(state);

export const isValidStateForBubbleOffer = (state: string) =>
  BUBBLE_VALID_STATES.includes(state);

export const isValidForPaintzenOffer = (zipCode: string) =>
  PAINTZEN_ZIP_CODES.includes(zipCode);

export const updateArcadiaSavingAmount = (arcadia: Reward) => {
  const arcadiaDeepCopy = JSON.parse(JSON.stringify(arcadia));

  arcadiaDeepCopy.collapsed.title = arcadiaDeepCopy.collapsed.title.replaceAll(
    '$100',
    '$40'
  );
  arcadiaDeepCopy.partnerLink = ARCADIA_URL_$40;
  arcadiaDeepCopy.expanded.title = arcadiaDeepCopy.expanded.title.replaceAll(
    '$100',
    '$40'
  );
  arcadiaDeepCopy.expanded.li[0] = arcadiaDeepCopy.expanded.li[0].replaceAll(
    '$100',
    '$40'
  );

  return arcadiaDeepCopy;
};

export const filterRewardsByState = (
  reward: Reward,
  state: string,
  zipCode: string
) => {
  let rewardDeepCopy = JSON.parse(JSON.stringify(reward));

  if (REWARDS_FILTER_LIST.includes(reward.name)) {
    if (reward.name === 'bubble' && !isValidStateForBubbleOffer(state)) {
      return null;
    }
    if (
      reward.name === 'clearestate' &&
      !isValidStateForClearEstateOffer(state)
    ) {
      return null;
    }
    if (reward.name === 'paintzen' && !isValidForPaintzenOffer(zipCode)) {
      return null;
    }
    if (reward.name === 'arcadia' && !ARCADIA_VALID_STATES.includes(state)) {
      rewardDeepCopy = updateArcadiaSavingAmount(reward);
    }
  }

  return rewardDeepCopy;
};

export const PARTNER_REQUIRES_REPORT = ['bubble', 'morty', 'clever'];
